import { formatEthWithFiatSingle } from '../utils/ethPrice';
import { useCurrency } from '../context/CurrencyContext';

/**
 * Renders an ETH amount with optional fiat equivalent (site-wide currency).
 * @param {number|string} ethAmount - Amount in ETH
 * @param {object} fiat - { usd, eur } price per 1 ETH (from getEthPriceInFiat)
 * @param {string} nativeSymbol - e.g. 'ETH' (displayed as "0.01 ETH")
 * @param {boolean} inline - if true, fiat is on same line in muted text; if false, fiat on new line
 * @param {object} style - optional container style
 */
export default function EthWithFiat({ ethAmount, fiat, nativeSymbol = 'ETH', inline = true, style = {} }) {
  const currency = useCurrency();
  const num = Number(ethAmount);
  const ethStr = Number.isNaN(num) ? '0' : num.toFixed(4);
  const fiatText = formatEthWithFiatSingle(ethAmount, fiat, currency);

  return (
    <span style={style}>
      <span>{ethStr} {nativeSymbol}</span>
      {fiatText && (
        inline ? (
          <span style={{ marginLeft: 6, color: '#9e9e9e', fontSize: '0.9em' }}>({fiatText})</span>
        ) : (
          <span style={{ display: 'block', color: '#9e9e9e', fontSize: '0.85em', marginTop: 2 }}>{fiatText}</span>
        )
      )}
    </span>
  );
}
